import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import modalTheme from '../../styles/modalTheme';
var ModalBody = styled.div.withConfig({
  displayName: "ModalBody",
  componentId: "sc-13pcilj-0"
})(["padding-bottom:", ";padding-left:", ";padding-right:", ";padding-top:", ";", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return rem(_get(theme, "modal.padding.v", modalTheme.modal.padding.v));
}, function (_ref2) {
  var theme = _ref2.theme;
  return rem(_get(theme, "modal.padding.h", modalTheme.modal.padding.h));
}, function (_ref3) {
  var theme = _ref3.theme;
  return rem(_get(theme, "modal.padding.h", modalTheme.modal.padding.h));
}, function (_ref4) {
  var theme = _ref4.theme;
  return rem(_get(theme, "modal.padding.v", modalTheme.modal.padding.v));
}, function (_ref5) {
  var $isContentCover = _ref5.$isContentCover;
  return $isContentCover && css(["@media (min-width:0){padding:0;}"]);
}, function (_ref6) {
  var hasDefaultFooter = _ref6.hasDefaultFooter;
  return !hasDefaultFooter && css(["@media (min-width:0){padding-bottom:", ";}"], function (_ref7) {
    var theme = _ref7.theme;
    return rem(_get(theme, 'modal.padding.v', modalTheme.modal.padding.v));
  });
});
export default ModalBody;